export default __webpack_public_path__ + "graphics/hands.bc9db602.jpg";